export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';
export type ButtonSize = 'sm' | 'md';

const BASE =
  'inline-flex items-center justify-center rounded-sm font-medium whitespace-nowrap select-none ' +
  'transition-tone pressable disabled:cursor-not-allowed';

const VARIANT: Record<ButtonVariant, string> = {
  primary:
    'bg-brand text-brand-ink border border-transparent hover:bg-brand-strong disabled:opacity-55',
  secondary:
    'bg-surface text-ink border border-line-strong hover:bg-surface-2 hover:border-ink-3 disabled:opacity-55',
  // A disabled ghost keeps its shape and goes quiet, rather than fading like a broken label.
  ghost:
    'bg-transparent text-ink-2 border border-transparent hover:bg-surface-3 hover:text-ink ' +
    'disabled:text-ink-3 disabled:hover:bg-transparent disabled:hover:text-ink-3',
  // ink-inverse is white on the light red and navy on the lighter dark red: both pass AA.
  danger:
    'bg-danger text-ink-inverse border border-transparent hover:brightness-95 disabled:opacity-55',
};

/* 32px and 28px tall: whole pixels, so the 1px border stays crisp. */
const SIZE: Record<ButtonSize, string> = {
  sm: 'h-7 px-2.5 text-body gap-1.5',
  md: 'h-8 px-3 text-body gap-2',
};

/**
 * The classes of a button. `Button` and `LinkButton` are built on it, and it serves the rare
 * element that must look like a button without being one (a plain anchor on the error page).
 */
export function buttonClass(
  variant: ButtonVariant = 'secondary',
  size: ButtonSize = 'md',
  className?: string,
): string {
  return [BASE, VARIANT[variant], SIZE[size], className].filter(Boolean).join(' ');
}
